<template>
	<v-card>
		<v-card-title class="d-flex align-center">
			<v-icon
				icon="$archive"
				start
			/>
			<translate>Archived direct debit files</translate>
		</v-card-title>
		<v-card-text>
			<span>
				<translate
					:translate-params="{
						num: num
					}"
				>
					Here are the last %{num} direct debit files that already have been sent to the bank.
				</translate>
			</span>
			<v-text-field
				v-model="idSearch"
				append-inner-icon="$search"
				:label="$gettext('Search by ID')"
				single-line
				hide-details
				variant="outlined"
			/>
			<model-backend-table
				v-model="items"
				v-model:options="options"
				endpoint="/bo/bankingfiles/archiveddirectdebitexportfiles"
				:filter="filter"
				:headers="tableHeaders"
				:server-items-length="totalItems"
				:items-per-page="20"
				:items-per-page-options="[20]"
			>
				<template #item.date="{ item }">
					<a :href="`/bo/bankingfiles/downloadDirectDebitExportFile?id=${item.id}`">
						{{ item.date }}
					</a>
				</template>
				<template #item.sum_transfers="{ item }">
					<span
						v-if="item.sumTransfers < 0"
						class="negative-currency"
					>
						€ {{ item.sumTransfers }}
					</span>
					<span v-else>
						€ {{ item.sumTransfers }}
					</span>
				</template>
				<template #item.processor="{ item }">
					<span v-if="item.processor">
						{{ item.processor }}
					</span>
					<span v-else>
						<process-direct-debit-file-button :id="item.id" />
					</span>
				</template>
				<template #item.actions="{ item }">
					<span>
						<v-btn
							variant="text"
							size="small"
							@click="submit(item.id)"
						>
							<translate>Regenerate</translate>
						</v-btn>
					</span>
				</template>
			</model-backend-table>
		</v-card-text>
	</v-card>
</template>

<script>

import {
	axios,
} from '../../services/axios-service';

export default {
	name: 'ArchivedDirectDebitFiles',

	props: {
		isAdmin: {
			type: Boolean,
			required: true,
		}
	},

	data () {
		return {
			items: [],
			num: 20,
			options: {
			},
			totalItems: 0,
			idSearch: '',
		};
	},

	computed: {
		tableHeaders () {
			const headers = [
				{
					title: this.$gettext('Date'), value: 'date', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Last downloaded at'), value: 'lastDownloadedAt', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Num transfers'), value: 'numTransfers', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Sum transfers'), value: 'sumTransfers', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('Processor'), value: 'processor', sortable: false, filterable: false,
				},
				{
					title: this.$gettext('ID'), value: 'id', sortable: false, filterable: true,
					filter: (value) => {
						return this.idSearch.length === 0 || this.idSearch.includes(value);
					}
				},
			];

			if (this.isAdmin) {
				headers.push({
					text: this.$gettext('Admin'), value: 'actions', sortable: false,
				});
			}
			return headers;
		},

		/**
		 * filter by id
		 *
		 * @returns {{fileId: string}}
		 */
		filter: function () {
			return {
				'fileId': this.idSearch,
			};
		}
	},

	methods: {

		/**
		 * Regenerate the direct debit file
		 *
		 * @param {number} id
		 */
		submit (id) {
			axios.post('/bo/bankingfiles/regenerateDirectDebitFile', {
				'id': id
			});
		}
	}
};
</script>
